// extracted by mini-css-extract-plugin
module.exports = {"avatarSection":"Avatar_avatarSection__2uVih","avatar":"Avatar_avatar__3J3es"};